// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.card {
  background: #fff;
  border-radius: 0.2rem;
  display: block;
  height: auto;
  margin: auto;
  width: 30rem;
  padding: 1rem;
  vertical-align: middle;
}
.card.video-player iframe {
  width: 28rem;
  height: 49.7777777778rem;
}
@media (min-width: 600px) {
  .card.video-player {
    width: 58rem;
  }
  .card.video-player iframe {
    width: 56rem;
    height: 31.5rem;
  }
}
.card.card-wide {
  width: unset;
  min-width: 30rem;
  max-width: calc(100vw - 2rem);
}
@media (min-width: 600px) {
  .card.card-wide {
    width: 47.5rem;
  }
}
.card .card-body form {
  padding: 2rem 0.5rem;
}
.card .card-caption {
  text-transform: uppercase;
  text-align: center;
  color: #292727;
}
.card .card-caption small {
  display: block;
}
.card .logo-wrapper {
  text-align: center;
}
.card .logo-wrapper img.logo {
  height: 5rem;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/Card/Card.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAEF;AACI;EACE,YAAA;EACA,wBAAA;AACN;AAEI;EANF;IAOI,YAAA;EACJ;EACI;IACE,YAAA;IACA,eAAA;EACN;AACF;AAGE;EACE,YAAA;EACA,gBAAA;EAGA,6BAAA;AAHJ;AAII;EANF;IAOI,cAAA;EADJ;AACF;AAKI;EACE,oBAAA;AAHN;AAME;EACE,yBAAA;EACA,kBAAA;EACA,cD9CQ;AC0CZ;AAKI;EACE,cAAA;AAHN;AAME;EACE,kBAAA;AAJJ;AAKI;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AAHN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.card {\n  background: #fff;\n  border-radius: 0.2rem;\n  display: block;\n  height: auto;\n  margin: auto;\n  width: 30rem;\n  padding: 1rem;\n  vertical-align: middle;\n\n  &.video-player {\n    iframe {\n      width: calc(30rem - 2rem);\n      height: calc(56rem / 31.5rem * (30rem - 2rem));\n    }\n\n    @media (min-width: $mobile) {\n      width: calc(56rem + 2rem);\n\n      iframe {\n        width: 56rem;\n        height: 31.5rem;\n      }\n    }\n  }\n\n  &.card-wide {\n    width: unset;\n    min-width: 30rem;\n    // width: 46.5rem;\n\n    max-width: calc(100vw - 2rem);\n    @media (min-width: $mobile) {\n      width: 47.5rem;\n    }\n  }\n\n  .card-body {\n    form {\n      padding: 2rem 0.5rem;\n    }\n  }\n  .card-caption {\n    text-transform: uppercase;\n    text-align: center;\n    color: $textColor;\n    small {\n      display: block;\n    }\n  }\n  .logo-wrapper {\n    text-align: center;\n    img.logo {\n      height: 5rem;\n      margin-bottom: 0.5rem;\n      margin-top: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
